import React, {useEffect} from "react";
import FormInput from "../components/form-input";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import BlockButton from "../components/block-button";
import {useNavigate} from "react-router-dom";
import keycloak from "../utils/keycloak";

type FormData = {
  carrierPostData: string;
  eid: string;
  iccid: string;
  displayName: string;
  deviceImei: string;
  deviceMeid: string;
  deviceType: string;
  primaryDeviceIccid: string;
};

const Workaround = () => {


  useEffect(() => {
    const primaryDeviceIccid = localStorage.getItem('primaryDeviceIccid');
    if(primaryDeviceIccid) {
      navigate("/activate-smartwatch");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { register, watch } = useForm<FormData>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigateNextPage = () => {
    if(watchedValues.displayName === 'change-env') {
      keycloak.logout();
    }
    else {
      localStorage.setItem("primaryIccid", watchedValues.primaryDeviceIccid);
      localStorage.setItem("eid", watchedValues.eid);
      localStorage.setItem('watchInfo', JSON.stringify(watchedValues));
      localStorage.setItem('deviceImei', watchedValues.deviceImei || "");
      navigate("/activate-smartwatch");
    }
  };

  const watchedValues = watch();

  return (
    <div className="layout-default">
      <div className="form-container">
        <FormInput
            data-testid="suffix"
            {...register("carrierPostData")}
            formText={t("CARRIER POST DATA")}
        />
        <FormInput
            data-testid="suffix"
            {...register("eid")}
            formText={t("EID")}
        />
        <FormInput
            data-testid="suffix"
            {...register("iccid")}
            formText={t("ICCID")}
        />
        <FormInput
            data-testid="suffix"
            {...register("displayName")}
            formText={t("DISPLAY NAME")}
        />
        <FormInput
            data-testid="suffix"
            {...register("deviceImei")}
            formText={t("DEVICE IMEI")}
        />
        <FormInput
            data-testid="suffix"
            {...register("deviceMeid")}
            formText={t("DEVICE MEID")}
        />
        <FormInput
            data-testid="suffix"
            {...register("deviceType")}
            formText={t("DEVICE TYPE")}
        />
        <FormInput
            data-testid="suffix"
            {...register("primaryDeviceIccid")}
            formText={t("PRIMARY DEVICE ICCID")}
        />
      </div>

      <BlockButton onClick={navigateNextPage} text={t("continueButton")} />
    </div>
  );
};

export default Workaround;
